import { PageType } from "@product/scmp-sdk";
import { useRouter } from "next/router";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import { tracking } from "~/data";
import type { postiesSectionSecondaryContentItemContent$key } from "~/queries/__generated__/postiesSectionSecondaryContentItemContent.graphql";

import {
  Container,
  Content,
  DateContainer,
  Headline,
  StyledArrowButton,
  StyledContentCoverImage,
  StyledEntityLink,
  StyledOffsetContainer,
} from "./styles";

export type Props = {
  reference: postiesSectionSecondaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemPostiesSectionSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, provider, reference: reference_ }, reference) => {
    const router = useRouter();

    const postiesSectionQueryParameters = {
      module: (router.query.name as string).toLowerCase().replaceAll(/[\s-]+/gi, "_"),
      pgtype: tracking.pageType.SectionPosties,
    };

    const content = useFragment(
      graphql`
        fragment postiesSectionSecondaryContentItemContent on Content {
          ...entityLink
          ...contentCoverImageContent
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink
          query={{ pageType: PageType.PostiesArticle, ...postiesSectionQueryParameters }}
          reference={content}
        >
          <StyledOffsetContainer borderRadius="12px">
            <StyledContentCoverImage
              reference={content}
              responsiveVariants={{
                desktopUp: "size320x240",
                mobileUp: "size540x360",
                tabletUp: "size320x240",
              }}
            />
          </StyledOffsetContainer>
          <Content>
            <Headline>
              {provider.headline({
                hideTag: true,
                preferSocialHeadline: true,
              })}
            </Headline>
            <DateContainer>{provider.publishedDate({})}</DateContainer>
            <StyledArrowButton />
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemPostiesSectionSecondary.displayName = "ContentItemPostiesSectionSecondary";
